import axios from './axios';

export const getTerminalRoles = async () => {
  const lstTerminal = await axios.get('user-terminal-role/');
  return lstTerminal.data;
};
